import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { PageSEO } from '../PageSEO';
import { InstitutionalNavbar } from '../institutional/InstitutionalNavbar';
import { InstitutionalFooter } from '../institutional/InstitutionalFooter';
import { ENTITY } from '../../lib/entity';

export function BookAppointment() {
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const controller = new AbortController();
    fetch('/api/public/appointments/config', { signal: controller.signal })
      .then(response => { if (!response.ok) throw new Error('Unavailable'); return response.json(); })
      .then(data => setBooking(data))
      .catch(() => { /* Keep the verified email route available. */ })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, []);
  return <div style={{ background: 'var(--gpc-paper)', minHeight: '100vh' }}>
    <PageSEO title="Book an Appointment | GP Capital" description="Arrange an introductory conversation with GP Capital about private capital, the platform or general business enquiries." path="/book-appointment" />
    <InstitutionalNavbar />
    <main className="gpc-container gpc-section" style={{ paddingTop: 140, paddingBottom: 100 }}>
      <p className="gpc-eyebrow">Appointments</p>
      <h1 className="gpc-h2 mt-4">A conversation, with a clear next step.</h1>
      <p className="gpc-body mt-6 max-w-2xl">Arrange an introductory conversation about your financing objective, capital-partner interest or a general business question. Private Capital and Home Loans follow separate processes.</p>
      <section className="company-panel mt-10 max-w-2xl" aria-labelledby="booking-heading">
        <h2 id="booking-heading" className="gpc-h3">Book an appointment</h2>
        <div aria-live="polite">
          {loading ? <p className="gpc-body mt-4" role="status">Checking online booking availability…</p> : booking?.enabled ? <>
            <p className="gpc-body mt-4">Choose an available time in the booking calendar. Your appointment confirmation and calendar invitation are managed by {booking.provider}.</p>
            <a className="gpc-cta-primary mt-6" href={booking.bookingUrl} target="_blank" rel="noopener noreferrer">Choose an available time ↗</a>
            <p className="gpc-body mt-4 text-sm">The booking page opens in a new tab. Only available appointment times are shared; private calendar events are not displayed on this website.</p>
          </> : <p className="gpc-body mt-4">Online scheduling is being configured. Email us to arrange a suitable time.</p>}
        </div>
        <a className="gpc-cta-secondary mt-6" href={`mailto:${ENTITY.contact.general}?subject=${encodeURIComponent('GP Capital — appointment request')}`}>Arrange a time by email →</a>
      </section>
      <p className="gpc-body mt-8 max-w-2xl">This is an introductory appointment, not a credit approval or a personalised lending recommendation. The Home Loans pathway remains in preparation pending the required authorisation.</p>
      <Link className="gpc-cta-secondary mt-8" to="/contact">View enquiry pathways →</Link>
    </main>
    <InstitutionalFooter />
  </div>;
}
